<div class="configure-modal">
    <h2 class="title">Configure Discount</h2>

    <form [formGroup]="discountForm">
        <!-- Rule -->
        <div class="section">
            <h3 class="section-title">Rule</h3>

            <div class="card">
                <div class="field">
                    <label>Based on</label>
                    <app-dropdown [data]="basedOnData" (selectedItemEvent)="selectBasedOn($event)"> </app-dropdown>
                </div>

                <div class="field">
                    <label>Operator</label>
                    <app-dropdown [data]="operatorData" (selectedItemEvent)="selectOperator($event)"> </app-dropdown>
                </div>

                <div class="field field--input">
                    <app-text-field
                        placeholder="Count*"
                        formControlName="count"
                        (input)="validateNumericInput('count')"
                    >
                    </app-text-field>
                </div>
            </div>
        </div>

        <!-- Discount -->
        <div class="section">
            <h3 class="section-title">Discount</h3>

            <div class="card card--two">
                <div class="field">
                    <label>Type</label>
                    <app-dropdown [data]="typeData" (selectedItemEvent)="selectType($event)"> </app-dropdown>
                </div>

                <div class="field field--input">
                    <app-text-field
                        placeholder="Discount Value*"
                        formControlName="discountValue"
                        (input)="validateNumericInput('discountValue')"
                    >
                    </app-text-field>
                </div>
            </div>
        </div>

        <!-- Expiry -->
        <div class="section">
            <h3 class="section-title">Rule Expiry date</h3>

            <div class="card date-card">
                <div>
                    <input
                        type="date"
                        class="j-text-field"
                        style="width: 200px; cursor: pointer; margin-right: var(--spacing-m)"
                        id="start-date"
                        formControlName="expirationDate"
                        (change)="setDate($event)"
                        [min]="minStartDate"
                        [max]="maxStartDate"
                    />
                </div>
            </div>
        </div>
    </form>
    <div class="discount-summary">
        For cycle with count {{ summaryOperatorDisplay }} {{ summaryCount }}, the user will get a discount of
        {{ discountValueText || 0 }} {{ summaryDiscountSymbol }}.
        <span *ngIf="summaryExpiryDisplay">The discount is applicable only till {{ summaryExpiryDisplay }}.</span>
    </div>
</div>

<div class="modal-actions">
    <button type="button" class="j-button j-button--type-1" (click)="cancel()">
        <span class="text-button">Cancel</span>
    </button>

    <button type="button" class="j-button j-button--type-2" (click)="save()">
        <span class="text-button">Save</span>
    </button>
</div>
